import React, { useState } from 'react'
import styled from '@emotion/styled'
import throttle from 'lodash.throttle'

import { Image } from '../Image'
import { BackgroundImage, BackgroundImageProps } from '../BackgroundImage'

const StyledBackgroundImage = styled(BackgroundImage)`
  &:hover img {
    opacity: 0;
  }
`

export interface ImageZoomProps extends BackgroundImageProps {
  srcZoom?: string
}

export const ImageZoom = ({
  src,
  srcZoom,
  onMouseMove,
  onMouseLeave,
  ...restProps
}: ImageZoomProps) => {
  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%')

  const updateBackgroundPosition = throttle(
    (bounds, pageX, pageY) => {
      const { left, top, width, height } = bounds

      const x = Math.round(((pageX - left) / width) * 100)
      const y = Math.round(((pageY - top) / height) * 100)

      setBackgroundPosition(`${x}% ${y}%`)
    },
    50,
    { trailing: false },
  )

  const handleMouseMove = event => {
    const bounds = event.target.getBoundingClientRect()
    const { pageX, pageY } = event

    updateBackgroundPosition(bounds, pageX, pageY)

    onMouseMove && onMouseMove(event)
  }

  const handleMouseLeave = event => {
    setBackgroundPosition('0% 0%')

    onMouseLeave && onMouseLeave(event)
  }

  return (
    <StyledBackgroundImage
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      backgroundImage={backgroundPosition !== '0% 0%' ? `url(${srcZoom || src})` : null}
      backgroundPosition={backgroundPosition}
      backgroundRepeat="no-repeat"
      transition="50ms ease background-position"
      {...restProps}
    >
      <Image
        display="block"
        width="100%"
        h="100%"
        objectFit="contain"
        pointerEvents="none"
        src={src}
      />
    </StyledBackgroundImage>
  )
}

export default ImageZoom
